import { render, staticRenderFns } from "./schoolDialog.vue?vue&type=template&id=3fe88868&scoped=true&"
import script from "./schoolDialog.vue?vue&type=script&lang=js&"
export * from "./schoolDialog.vue?vue&type=script&lang=js&"
import style0 from "./schoolDialog.vue?vue&type=style&index=0&id=3fe88868&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe88868",
  null
  
)

export default component.exports